module.exports = __webpack_public_path__ + "static/img/97.801bc92e.gif";